import { useEffect, useState } from "react";
import api from "../lib/api";
import { CalendarDays, Sparkles } from "lucide-react";

const KIND_TONE = {
  festival:      "bg-rose-50 text-rose-800 border-rose-200",
  national:      "bg-indigo-50 text-indigo-800 border-indigo-200",
  cultural:      "bg-amber-50 text-amber-800 border-amber-200",
  tourism:       "bg-emerald-50 text-emerald-800 border-emerald-200",
  sustainability:"bg-teal-50 text-teal-800 border-teal-200",
};

export default function ImportantDaysCard() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get("/social-media/important-days?days_ahead=45")
      .then(r => setRows(r.data || []))
      .catch(() => setErr(true));
  }, []);
  if (err) return null;
  const soon = rows.slice(0, 8);
  return (
    <div className="aii-card p-4" data-testid="important-days-card">
      <div className="flex items-center gap-2 mb-2">
        <CalendarDays className="text-brand" size={18}/>
        <h3 className="text-lg font-semibold">Important days · plan your content</h3>
      </div>
      {soon.length === 0 ? (
        <div className="text-sm text-[color:var(--aii-muted)] py-4">No cultural / tourism moments in the next 45 days. Enjoy the breather.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
          {soon.map(r => (
            <div key={r.name + r.date} className={`border rounded p-2.5 text-sm ${KIND_TONE[r.kind] || "bg-white border-[color:var(--aii-border)]"}`} data-testid={`imp-day-${r.name.replace(/\s+/g, '-').toLowerCase()}`}>
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-[10px] uppercase tracking-widest font-semibold opacity-80">{r.kind}</span>
                <span className="text-[10px] font-bold">{r.days_until}d</span>
              </div>
              <div className="font-semibold leading-tight" title={r.name}>{r.name}</div>
              <div className="text-[11px] opacity-80">{new Date(r.date).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })} · {r.region}</div>
            </div>
          ))}
        </div>
      )}
      <div className="text-[10px] text-[color:var(--aii-muted)] mt-2 flex items-center gap-1"><Sparkles size={10}/> Tap a day when you're planning a post so the whole team knows what's coming next.</div>
    </div>
  );
}
